import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ClientTable from 'components/ClientTable'
import { loadClientList, deleteClient } from 'store/actions/clientActions'
import { throttle } from 'lodash'
import { CSVDownload, CSVLink } from 'react-csv';
import NewClientModal from 'components/NewClientModal'
import { Helmet } from 'react-helmet'
import { Route, Switch, useRouteMatch } from "util/router.js";
import ClientPage from 'components/ClientPage'
import ClientSeenSelector from 'components/Form/ClientSeenSelector';
import * as moment from 'moment'

function ClientsSection(props) {

    const dispatch = useDispatch();

    const userId = useSelector(state => state.instructor?.instructor?.platformID)

    const BLOCK_CLIENT_LIST = ['Fez7c5FfC6gRjnkVBDINEkk6HD82', 'M4UOAwqAdbMrTg1l0nVlCKfIbEp2', '0KKQLKrSz7dRDtnVcZki8cKNTjb2'].includes(userId)
    useEffect(() => {
        if (userId) {
            dispatch(loadClientList(userId))
        }
    }, [dispatch, userId])

    const clients = useSelector(state => state.clients.clients.map(val => {
        let name = val.name
        if (val.lastName && val.firstName) {
            name = `${val.firstName} ${val.lastName}`
        } else if (val.firstName) {
            name = val.firstName
        } else if (!name) {
            name = "unknown"
        }
        let email = val.email || "unknown"
        // let phone = val.phone || val.phoneNumber || "unknown"
        // let marketingOptIn = val.marketingOptIn === false ? false : true
        let lastInteractionTimestamp = val.lastInteractionTimestamp ?? 1614219101
        let firstInteractionTimestamp = val.firstInteractionTimestamp ?? 1614219101
        return {
            // ...val,
            platformID: val.platformID,
            firstName: val.firstName,
            lastName: val.lastName,
            lastSeen: lastInteractionTimestamp,
            firstSeen: firstInteractionTimestamp,
            name,
            email,
            marketingOptIn: val.marketingOptIn ? "TRUE" : "FALSE",
            searchTerms: [name.toLowerCase(), email.toLowerCase()]
        }
    }))

    // const [filteredClients, setFilteredClients] = React.useState([])
    const [searchTerm, setSearchTerm] = React.useState("");
    const [clientFilters, setClientFilters] = React.useState(null)
    const [searchResults, setSearchResults] = React.useState([]);
    const handleChange = event => {
        setSearchTerm(event.target.value);
    };
    const handleChangeThrottle = throttle(handleChange, 5000)

    // {
    //     label: "Clients who joined within the last",
    //     value: "firstSeen_greaterThan" // first seen greater then 60 days ago
    // },
    // {
    //     label: "Clients who I have not seen within the last",
    //     value: "lastSeen_lessThan" // last seen less then 60 days ago
    // },
    // {
    //     label: "Clients who have attended within the last",
    //     value: "lastSeen_greatThan" // last seen greater then 60 days ago
    // }
    React.useEffect(() => {

        const NOW = Date.now()

        console.log("CLIENT FILTERS: ", clientFilters)
        const results = clients.filter(val =>{
            if (clientFilters?.span && clientFilters?.days) {
                switch (clientFilters.span) {
                case "firstSeen_greaterThan":
                    const date1 = (NOW / 1000) - (clientFilters.days * 86400)
                    console.log("DATE: ", date1)
                    console.log("FIRST: ", val.firstSeen)
                    if (val.firstSeen < date1) {
                        return false
                    }
                    break;
                case "lastSeen_lessThan":
                    const date2 = (NOW / 1000) - (clientFilters.days * 86400)
                    console.log("DATE: ", date2)
                    console.log("FIRST: ", val.firstSeen)
                    if (val.lastSeen > date2) {
                        return false
                    }
                    break;
                case "lastSeen_greatThan":
                    const date3 = (NOW / 1000) - (clientFilters.days * 86400)
                    console.log("DATE: ", date3)
                    console.log("FIRST: ", val.firstSeen)
                    if (val.lastSeen < date3) {
                        return false
                    }
                    break;
                }
            }
            if (!searchTerm) {
                return true
            }
            if (val.searchTerms) {
                for (const term of val.searchTerms) {
                    if (term && term.includes(searchTerm.toLowerCase())) {
                        return true
                    }
                }
            }
            return false
        })
        // .filter(val => {

        // });
        setSearchResults(results);
    }, [searchTerm, clientFilters]);

    function handleRemoveClient(val) {
        console.log("Removing client")
        console.log(val)
        dispatch(deleteClient(val))
    }

    const dataExport =
    // // clients
    (searchResults.length > 0 ? searchResults : clients)
    .map(val => {
        if (BLOCK_CLIENT_LIST) {
            delete val.firstSeen
            delete val.lastSeen
            return {
                ...val
            }
        }
        return {
            ...val,
            firstSeen: moment((val.firstSeen ?? 0) * 1000).toISOString(),
            lastSeen: moment((val.lastSeen ?? 0) * 1000).toISOString()
        }
    });

    let exportHeaders = [
        { label: "Client Name", key: "name" },
        { label: "First Name", key: "firstName" },
        { label: "Last Name", key: "lastName" },
        { label: "Client Email", key: "email" },
        { label: "Phone Number", key: "phone" },
        { label: "Marketing Opt-in", key: "marketingOptIn" },
    ]

    if (!BLOCK_CLIENT_LIST) {
        exportHeaders = [
            ...exportHeaders,
            { label: "First Seen", key: "firstSeen" },
            { label: "Last Seen", key: "lastSeen" }
        ]
    }

    const [showNewClient, setShowNewClient] = React.useState(false)
    const [showFilters, setShowFilters] = React.useState(false)

    return (
        <div className="container px-0  ">
            <Helmet>
                <title>Client List</title>
            </Helmet>
            <NewClientModal
                show={showNewClient}
                onHide={() => setShowNewClient(false)}
            />
            <div id='export-clients-div'></div>
            <section className="mb-5">
                <h2 className="font-weight-bold mb-5">Client List</h2>
                <div className="row">
                    <div className="col-md-8 mb-3">
                        <input className="form-control" type="text" placeholder="Search" aria-label="Search" value={searchTerm} onChange={handleChangeThrottle} />
                    </div>
                    <div className="col-md-4 d-flex d-row justify-content">
                        {/* <button type="submit" className="btn btn-primary">Save changes</button> */}
                        <div className="pr-2">
                            <CSVLink className="btn btn-light" filename={`Client_List.csv`} data={dataExport} headers={exportHeaders}>
                                Export CSV
                            </CSVLink>

                            <div className={BLOCK_CLIENT_LIST ? "d-none" : ""}>
                                <button onClick={() => {
                                    setShowFilters(true)
                                }} type="button" className={"btn btn-secondary " + (showFilters ? "d-none" : "")}>
                                    Show Filters
                                </button>
                                <button onClick={() =>  {
                                    setClientFilters({})
                                    setShowFilters(false)
                                }} type="button" className={"btn btn-link " + (showFilters ? "" : "d-none")}>
                                    Reset Filters
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <ClientSeenSelector handleApply={(e) => setClientFilters(e)} showFilters={showFilters} />
            </section>
            <section>
                <ClientTable
                    blockList={BLOCK_CLIENT_LIST}
                    clients={(!searchTerm && !clientFilters) ? clients : searchResults}
                    handleRemoveClient={handleRemoveClient}
                />
            </section>
        </div>

    )
}

function ClientsPage(props) {

    const match = useRouteMatch()

    return (
        <Switch>
            <Route
                path={`${match.url}/:userId`}
                render={props => {
                    return (
                        <ClientPage />
                    )
                }}
            />
            <Route path="/">
                <ClientsSection />
            </Route>
        </Switch>
    );
}

export default ClientsPage